import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/ladmakare/behaviors/addProduct';

export const sectionsProductListConfig: ProductListConfig = {
  cardsSubtitle: 'communicatedSizeText',
  mobileCardText: 'communicatedSizeText',
  categories: [
    {
      id: 'sections',
      categoryTitle: 'storageone.productListLadmakareTitle',
      products: [{ path: 'type', value: ProductType.LADMAKARE_SECTION_WITH_SHELVES }]
    },
    {
      id: 'interiors',
      categoryTitle: 'storageone.productListLadmakareInteriorTitle',
      cardsSubtitle: 'typeName',
      products: [
        { path: 'type', value: ProductType.LADMAKARE_CABINET },
        { path: 'type', value: ProductType.LADMAKARE_COMPARTMENT }
      ]
    }
  ],
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  cluster: [],
  sortOrder: [
    { path: 'dimensions.height', reverse: true },
    { path: 'dimensions.width', reverse: true }
  ],
  productFilters: []
};
